var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    staticClass: "navbar",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('hamburger', {
    directives: [{
      name: "stream",
      rawName: "v-stream:click",
      value: (_vm.toggleSideBar$),
      expression: "toggleSideBar$",
      arg: "click"
    }],
    staticClass: "hamburger-container",
    attrs: {
      "is-active": _vm.sidebarStatus
    }
  }), _c('levelbar'), _c('div', {
    staticClass: "avatar-container"
  }, [_c('div', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.userName || '未登录'))]), _c('icon-svg', {
    staticClass: "logout",
    attrs: {
      "icon-class": "Logout"
    },
    nativeOn: {
      "click": function($event) {
        _vm.logout($event)
      }
    }
  })], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-36743b5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36743b5e","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Navbar.vue
// module id = X4Gi
// module chunks = 1